module.exports = __webpack_public_path__ + "img/symbol_2.026dbbe9.png";